import { render, staticRenderFns } from "./CompanyPrintHeader.vue?vue&type=template&id=40b867ce&"
import script from "./CompanyPrintHeader.vue?vue&type=script&lang=ts&"
export * from "./CompanyPrintHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports